<template>
  <div class="about">
<!--page title start-->

<!-- <section class="page-title animatedbg dark-bg text-center" data-bg-img="images/pattern/01.png">
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>About Us</h1>
        <nav aria-label="breadcrumb" class="page-breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html">Home</a>
            </li>
            <li class="breadcrumb-item"><a href="#">Pages</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">About Us</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</section> -->
<!--page title end-->

<div id="main-page" class="page-content">

<!--feature start-->

<section class="pos-r">
  <div id="particles-js"></div>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h6>Why Choose Us</h6>
          <h2 class="title mb-0">We’re a full-service <span>design agency</span></h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-ui"></i>
            <span>01</span>
          </div>
          <div class="featured-title">
            <h5>UX Design</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-domain"></i>
            <span>02</span>
          </div>
          <div class="featured-title">
            <h5>Development</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="featured-item style-2 text-center">
          <div class="featured-icon"> <i class="flaticon-challenges"></i>
            <span>03</span>
          </div>
          <div class="featured-title">
            <h5>Strategy</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy surrounding the filler text Agencio</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--feature end-->


<!--about start-->

<section class="py-3">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-lg-6 col-12">
        <img class="img-fluid w-100 box-shadow" src="images/bg/01.jpg" alt="">
        <div class="row mt-4">          
          <div class="col-sm-6 order-sm-1">
             <img class="img-fluid w-100 box-shadow" src="images/bg/02.jpg" alt="">
          </div>
          <div class="col-sm-6 mt-4 mt-sm-0">
            <div class="theme-bg p-4 box-shadow">
                <h3 class="text-white mb-0 font-w-5">20+ Years Experience of Business </h3>
            </div>           
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-12 mt-5 mt-lg-0 ml-auto">
        <div class="section-title">
          <h6>About US</h6>
          <h2 class="title">We are Design and Development <span>based on Agencio</span></h2>
          <p class="lead mb-0">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering the source behind the ubiquitous</p>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="counter">
              <div class="d-flex align-items-center">
                <div class="counter-icon ml-3"> <i class="flaticon-suitcase"></i>
                </div> <span class="count-number" data-to="900" data-speed="4000">900</span>
              </div>
              <h6>Lot's Of Work Completed</h6>
            </div>
          </div>
          <div class="col-sm-6 mt-5 mt-sm-0">
            <div class="counter">
              <div class="d-flex align-items-center">
                <div class="counter-icon ml-3"> <i class="flaticon-trophy"></i>
                </div> <span class="count-number" data-to="400" data-speed="4000">400</span>
              </div>
              <h6>Best Awards Winning</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--about end-->


<!--team start-->

<section class="pb-0">
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="team-member">
          <h5><a href="team-single.html">Jesson<br>Mart</a></h5>
          <div class="team-images">
            <img class="img-fluid" src="images/team/01.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 md-mt-5">
        <div class="team-member">
          <h5><a href="team-single.html">Michael<br>Vegas</a></h5>
          <div class="team-images">
            <img class="img-fluid" src="images/team/02.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 md-mt-5">
        <div class="team-member">
          <h5><a href="team-single.html">Charlote<br>Kerry</a></h5>
          <div class="team-images">
            <img class="img-fluid" src="images/team/03.jpg" alt="">
          </div>
          <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team end-->


<section>
  <div class="container-fluid pl-lg-0">
    <div class="row align-items-center">
      <div class="col-lg-5 col-12 mr-auto">
        <div class="section-title">
          <div class="section-title">
          <h2 class="titl">We’re Partnering With <span>Your Favorite Brand</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
          
        </div>
        <div class="row">
      <div class="col-md-4 col-12">
        <img class="img-fluid" src="images/client/07.png" alt="">
      </div>
      <div class="col-md-4 col-12">
        <img class="img-fluid" src="images/client/08.png" alt="">
      </div>
      <div class="col-md-4 col-12">
        <img class="img-fluid" src="images/client/09.png" alt="">
      </div>
      <div class="col-md-4 col-12 mt-5">
        <img class="img-fluid" src="images/client/10.png" alt="">
      </div>
      <div class="col-md-4 col-12 mt-5">
        <img class="img-fluid" src="images/client/11.png" alt="">
      </div>
      <div class="col-md-4 col-12 mt-5">
        <img class="img-fluid" src="images/client/12.html" alt="">
      </div>
    </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="box-shadow p-5 pos-r">
          <div class="img-bg">
          <svg class="morph-shape" viewBox="0 0 500 500">
              <defs>
                <linearGradient id="main-gradien" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="10%" style="stop-color:#0083ff;"></stop>
                  <stop offset="100%" style="stop-color:#00f2aa;"></stop>
                </linearGradient>
              </defs>
              <path id="object" class="js-items-shape-path" fill="url(#main-gradien)" d="M418.1 159.8 C460.9 222.9 497 321.5 452.4 383.4 417.2 432.4 371.2 405.6 271.3 420.3 137.19 440 90.45 500.6 42.16 442.8 -9.57 381 86.33 289.1 117.7 215.5 144.3 153.4 145.69 54.21 212.7 36.25 290.3 15.36 373.9 94.6 418.1 159.8 " data-original="M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z"></path>
            </svg>
        </div>
          <div class="owl-carousel" data-items="1" data-autoplay="true">
          <div class="item">
            <div class="testimonial style-3 shadow-none">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Alvi Miller</h5>
                      <label>Founder of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
          <div class="item">
            <div class="testimonial style-3 shadow-none">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Albert Jonson</h5>
                      <label>CEO of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!--blog start-->

<section class="pt-lg-0">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Blog</h6>
          <h2 class="title">Read Our <span>Latest News</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12">
        <div class="post">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div>
            <p>Agencio discovering the source behind the filler In seeing a sample</p> <a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>
  </div>
</template>

<script>


export default {
    data: function () {
        return {
            name: 'About Us',
        }
    },
};
</script>
